export default "__VITE_ASSET__ed50bfed__"